import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './Invoice/Main';
import Form from './Invoice/Form';

// Utils
import {
  getAlert,
  getClearLocalStorage,
  getDataWithComp,
  getMaxInvNo
} from '../../../utils/SamuiUtils';

const Invoice = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [maxInvNo, setMaxInvNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp('INV_H', `ORDER BY Doc_No DESC`);
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      // หาค่าสูงของ DocNo ใน INV_H สำหรับ INV (ใบกำกับภาษี)
      const maxInv = getMaxInvNo(masterList);
      setMaxInvNo(maxInv);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onPageUpdate = (docNo) => {
    setMaxInvNo(docNo);
    setMode('U')
  };

  return (
    <div>
      <div className="Invoice">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <Main
                    name={'ใบกำกับภาษี'}
                    dataMasterList={dataMasterList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(docNo) => onPageUpdate(docNo)}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={'ใบกำกับภาษี'}
                    docNo={maxInvNo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;